import React from 'react';
import { useTranslation } from 'react-i18next';
import { JoraEmployerHelmet } from '@common/components/Helmet';
import { PageHeadingWithUserPackage } from '@common/components/PageHeadingWithUserPackage';
import { useRedirectUnauthenticatedUser } from '@common/hooks/useRedirectUnauthenticatedUser';
import { Box } from '@components/Box';
import { Stack } from '@components/Stack';
import { CoinFaqSection, CoinSummary, CoinTransactions } from './components';
import { useRedirectIfCoinsDisabled } from './hooks';

export const MyCoins = () => {
  const { t } = useTranslation();

  useRedirectUnauthenticatedUser();
  useRedirectIfCoinsDisabled();

  return (
    <Stack tone="transparent">
      <JoraEmployerHelmet title={t('myCoinsPage.title')} />

      <Stack spacing="small" tone="transparent" marginBottom="large">
        <Box paddingTop="medium" paddingHorizontal="medium" tone="transparent">
          <PageHeadingWithUserPackage heading={t('myCoinsPage.heading')} />
        </Box>

        <CoinSummary />

        <CoinTransactions />

        <CoinFaqSection showExpiryInformation={true} />
      </Stack>
    </Stack>
  );
};
